module.exports = vendors_tr_92dcd27f6e0c569963e0;